import * as React from "react";
import styled from "styled-components";
import { Label } from "components/bootstrap";
import { Icon } from "components/common";
import { IconButton } from "./styled.components";
const Heading = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;
const Title = styled.h2`
  margin-left: 1rem;
`;
const CountLabel = styled(Label)`
  font-size: 14px;
  margin-left: 0.5rem;
`;
const EvidenceSectionHeader = ({
  action = void 0,
  count,
  isExpanded,
  onToggleExpanded,
  sectionName,
  title
}) => /* @__PURE__ */ React.createElement(Heading, null, /* @__PURE__ */ React.createElement(IconButton, { "aria-label": `Toggle ${title}`, onClick: () => onToggleExpanded(sectionName) }, isExpanded ? /* @__PURE__ */ React.createElement(Icon, { name: "keyboard_arrow_up" }) : /* @__PURE__ */ React.createElement(Icon, { name: "keyboard_arrow_down" }), /* @__PURE__ */ React.createElement(Title, null, title), /* @__PURE__ */ React.createElement(CountLabel, null, count)), action);
export default EvidenceSectionHeader;
